<template>
  <div class="animated fadeIn">
    <div class="pt-5">
      <b-row class="justify-content-center">
        <b-col md="8">
          <div class="display-4 text-center pb-5">Before we begin</div>
          <p>
            You are responsible for entering correct and complete submission
            information. In the event of any data errors we will work with you
            to resolve them, but can not accept responsibility for incorrect
            submissions.
          </p>
          <b-alert :show="!isSignedIn" variant="warning">
            <strong>You are not logged in.</strong> If you would like to link
            your order to an account please
            <router-link to="/login">log in</router-link> or
            <router-link to="/register">register</router-link>. If you choose to
            continue you will be proceeding as a guest.
          </b-alert>
          <b-button
            variant="primary"
            size="lg"
            class="mt-5 w-25 d-block mx-auto"
            to="/submissions/add/step/1"
            >Begin</b-button
          >
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { AUTH_CHECK_LOGIN } from "@/store/action-types";

export default {
  name: "SubmissionAdd",
  data() {
    return {
      signed_in: false
    };
  },
  computed: {
    isSignedIn() {
      return this.signed_in;
    }
  },
  async beforeCreate() {
    this.$store
      .dispatch(AUTH_CHECK_LOGIN, {})
      .then(data => {
        this.signed_in = true;
      })
      .catch(e => {
        this.signed_in = false;
      });
  }
};
</script>
